import {getCurrentDate} from './date';
import {
  convertToDollar,
} from './money';
export const PAYDAY = [1, 15];
export const calculateContributonFromAutoPayAmount = (autoPayAmount, numberOfPurchasePeriod) => {
  return autoPayAmount * numberOfPurchasePeriod * PAYDAY.length;
};

export const calculateAutoPayAmount = (contributionAmountInCents, numberOfPurchasePeriod) => {
  return convertToDollar(contributionAmountInCents) / (numberOfPurchasePeriod * PAYDAY.length);
};

export const getNextAutoPaymentDate = () => {
  const currentDate = getCurrentDate(false);
  const currentDay = currentDate.format('D');
  const currentMonth = Number(currentDate.format('M'));
  const currentYear = Number(currentDate.format('YYYY'));
  if (currentDay < PAYDAY[1]) {
    return (`${currentMonth}/15/${currentYear}`);
  }
  if (currentMonth === 12) {
    return (`01/${PAYDAY[0]}/${currentYear + 1}`);
  }
  return (`${currentMonth + 1}/01/${currentYear}`);
};
